import { memoize } from 'lodash';
import getClientConfig from './getClientConfig';

export default memoize(() => getClientConfig().apiRoot || `${window.location.protocol}//${window.location.host}`);
